import { render, staticRenderFns } from "./ProviderDiscount.vue?vue&type=template&id=5067173e&scoped=true"
import script from "./ProviderDiscount.vue?vue&type=script&lang=js"
export * from "./ProviderDiscount.vue?vue&type=script&lang=js"
import style0 from "./ProviderDiscount.vue?vue&type=style&index=0&id=5067173e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067173e",
  null
  
)

export default component.exports